/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_GETCODE } from '../actions/auth'
import { USER_REQUEST } from '../actions/user'
import apiCall from '../../utils/api'
import router from '../../router'
import Cookies from 'js-cookie'

const state = { token: Cookies.get('access_token') || '', status: '', hasLoadedOnce: false, errors: {} }

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  token: state => state.token
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, code) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      apiCall({url: '/api/singleauthtoken/' + code, method: 'GET'})
        .then(resp => {
          Cookies.set('access_token', resp.access_token, { expires: resp.expires_in / (3600 * 24) })
          Cookies.set('refresh_token', resp.refresh_token)
          // Here set the header of your ajax library to the token value.
          // example with axios
          // axios.defaults.headers.common['Authorization'] = resp.token
          commit(AUTH_SUCCESS, resp)
          dispatch(USER_REQUEST)
          resolve(resp)
        })
        .catch(err => {
          commit(AUTH_ERROR, err.data)
          Cookies.remove('access_token')
          Cookies.remove('refresh_token-token')
          Cookies.remove('expires')
          reject(err)
        })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      Cookies.remove('access_token')
      Cookies.remove('refresh_token-token')
      Cookies.remove('refresh_token')
      Cookies.remove('expires')
      indexedDB.deleteDatabase('localforage')
      router.push('/login')
      resolve()
    })
  },
  [AUTH_GETCODE]: ({commit, dispatch}, number) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      apiCall({url: 'api/singleauthtoken/request/' + number, method: 'GET'})
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          commit(AUTH_ERROR, err.data)
          reject(err)
        })
    })
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.access_token
    state.errors = {}
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state, err) => {
    state.status = 'error'
    state.errors = err
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js